const a = "{{currentTime}} daripada {{duration}}", n = "Hasil carian {{current}} daripada {{total}}", t = "Tiada hasil carian ditemui", s = "{{count}} hasil ditemui", o = "{{count}} hasil ditemui", T = 'Dimainkan dari $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) dan $t(SECONDS, { "count": {{seconds}} }).', A = 'Dimainkan dari $t(MINUTES, { "count": {{minutes}} }) dan $t(SECONDS, { "count": {{seconds}} }).', i = 'Dimainkan dari $t(SECONDS, { "count": {{seconds}} }).', E = "Ralat menyimpan perubahan pada transkrip", c = "Baris transkrip pada {{time}}. Kandungan ialah: {{text}}.", e = 'Bekas baris transkrip. Terdapat $t(TRANSCRIPT_LINES, { "count": {{count}} }) dalam bekas ini. Untuk menavigasi dalam bekas ini gunakan kekunci anak panah ke bawah.', S = "Menyimpan perubahan...", _ = "Perubahan disimpan pada transkrip.", u = "Butang kemas kini kapsyen kini tersedia.", N = "Tindakan", R = "Tambah anotasi pada {{time}}", O = "Tambah soalan pada {{time}}", I = "Anotasi", r = "Automatik", k = "Auto ({{quality}})", C = "Kembali", P = "Kapsyen", U = "Bahasa Kapsyen", l = "Urus Kapsyen", m = "Padam {{language}}", d = "Saiz Fon", p = "Bahasa Kapsyen: {{language}}", L = "{{language}} (automatik)", M = "Kosongkan Carian", D = "Tutup", K = "Komen", h = "Teruskan", g = "Kurangkan Kelajuan Main Semula", B = "Kurangkan Kelantangan Sebanyak {{percent}}%", G = "Anak Panah ke Bawah", Y = "Tutup Editor Transkrip", y = "Kemas Kini Kapsyen", H = "Ralat!", b = "Menyimpan...", V = "Disimpan!", F = "Edit Transkrip", j = "Teks tidak boleh kosong!", J = "Skrin penuh", W = "{{count}} jam", $ = "{{count}} jam", Q = "Tingkatkan Kelajuan Main Semula", x = "Tingkatkan Kelantangan Sebanyak {{percent}}%", z = "Songsangkan Warna", Z = "Terus ke peratusan tertentu (1-10%, 2-20%, dll)", v = "Terus ke Mula", w = "Tindakan untuk {{title}}", X = "Pintasan Papan Kekunci", f = "Bahasa", q = "Panah Kiri", aa = "Menu Utama", na = "{{count}} minit", ta = "{{count}} minit", sa = "Bisukan", oa = "Diredamkan", Ta = "Bahasa Kapsyen Seterusnya", Aa = "Hasil carian seterusnya", ia = "Mati", Ea = "Di Bahagian Atas", ca = "Buka anotasi pada {{time}}", ea = "Buka kuiz yang diselesaikan pada {{time}}", Sa = "Buka kuiz pada {{time}}", _a = "Jedakan", ua = "Mainkan", Na = "Kelajuan Main Semula", Ra = "Kelajuan Main Semula: {{speed}}x", Oa = "Bahasa Kapsyen Sebelumnya", Ia = "Hasil carian seterusnya", ra = "Kualiti", ka = "Menu Kualiti", Ca = "Main Semula", Pa = "Tetapkan Semula Kelajuan Main Semula", Ua = "Anak Panah ke Kanan", la = "Cari dalam transkrip", ma = "{{count}} saat", da = "{{count}} saat", pa = "Cari ke belakang: {{seconds}} saat", La = "Cari ke depan: {{seconds}} saat", Ma = "Tetapan", Da = "Pintasan", Ka = "Butiran media dan alatan", ha = "Jarak", ga = "Menu Kelajuan Main Semula", Ba = "Mulakan Autotatal", Ga = "Togol Kapsyen", Ya = "Togol Dibisukan", ya = "Togol Main/Jeda", Ha = "{{count}} baris transkrip", ba = "{{count}} baris transkrip", Va = "Memuatkan transkrip...", Fa = "Kami tidak dapat memuatkan transkrip.", ja = "Pilihan Transkrip", Ja = "Cuba semula", Wa = "Transkrip tidak tersedia", $a = "Anak Panah Ke Atas", Qa = "Tetapan Video", xa = "Kelantangan", za = "Kelantangan: {{volume}}%", Za = {
  A11Y_DURATION: a,
  A11Y_SEARCH_HITS: n,
  A11Y_SEARCH_NO_RESULTS: t,
  A11Y_SEARCH_RESULTS_FOUND: s,
  A11Y_SEARCH_RESULTS_FOUND_other: o,
  A11Y_TIMESTAMP_JUMP_HOURS: T,
  A11Y_TIMESTAMP_JUMP_MINUTES: A,
  A11Y_TIMESTAMP_JUMP_SECONDS: i,
  A11Y_TRANSCRIPT_ERROR: E,
  A11Y_TRANSCRIPT_LINE: c,
  A11Y_TRANSCRIPT_LINES: e,
  A11Y_TRANSCRIPT_SAVING: S,
  A11Y_TRANSCRIPT_SUCCESS: _,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: u,
  ACTION: N,
  ADD_ANNOTATION_AT: R,
  ADD_QUESTION_AT: O,
  ANNOTATIONS: I,
  AUTO: r,
  AUTO_QUALITY: k,
  BACK: C,
  CAPTIONS: P,
  CAPTIONS_LANGUAGE: U,
  CAPTIONS_MANAGE: l,
  CAPTION_DELETE: m,
  CAPTION_FONT_SIZE: d,
  CAPTION_LANGUAGE: p,
  CAPTION_LANGUAGE_AUTOMATIC: L,
  CLEAR_SEARCH: M,
  CLOSE: D,
  COMMENTS: K,
  CONTINUE: h,
  DECREASE_PLAYBACK_SPEED: g,
  DECREASE_VOLUME: B,
  DOWN_ARROW: G,
  EDIT_CLOSE: Y,
  EDIT_CONFIRM: y,
  EDIT_ERROR: H,
  EDIT_SAVING: b,
  EDIT_SUCCESS: V,
  EDIT_TRANSCRIPT: F,
  EDIT_VALIDATION_ERROR: j,
  FULLSCREEN: J,
  HOURS: W,
  HOURS_other: $,
  INCREASE_PLAYBACK_SPEED: Q,
  INCREASE_VOLUME: x,
  INVERT_COLORS: z,
  JUMP_TO_PERCENTAGE: Z,
  JUMP_TO_START: v,
  KEBAB_MENU: w,
  KEYBOARD_SHORTCUTS: X,
  LANGUAGE: f,
  LEFT_ARROW: q,
  MAIN_MENU: aa,
  MINUTES: na,
  MINUTES_other: ta,
  MUTE: sa,
  MUTED: oa,
  NEXT_CAPTION_LANGUAGE: Ta,
  NEXT_HIT: Aa,
  OFF: ia,
  ON_TOP: Ea,
  OPEN_ANNOTATION_AT: ca,
  OPEN_COMPLETED_QUIZ_AT: ea,
  OPEN_QUIZ_AT: Sa,
  PAUSE: _a,
  PLAY: ua,
  PLAYBACK_SPEED: Na,
  PLAYBACK_SPEED_MESSAGE: Ra,
  PREVIOUS_CAPTION_LANGUAGE: Oa,
  PREVIOUS_HIT: Ia,
  QUALITY: ra,
  QUALITY_MENU: ka,
  REPLAY: Ca,
  RESET_PLAYBACK_SPEED: Pa,
  RIGHT_ARROW: Ua,
  SEARCH_TRANSCRIPT_PLACEHOLDER: la,
  SECONDS: ma,
  SECONDS_other: da,
  SEEK_BACKWARD: pa,
  SEEK_FORWARD: La,
  SETTINGS: Ma,
  SHORTCUT: Da,
  SIDEBAR: Ka,
  SPACE: ha,
  SPEED_MENU: ga,
  START_AUTOSCROLL: Ba,
  TOGGLE_CAPTIONS: Ga,
  TOGGLE_MUTED: Ya,
  TOGGLE_PLAY_PAUSE: ya,
  TRANSCRIPT_LINES: Ha,
  TRANSCRIPT_LINES_other: ba,
  TRANSCRIPT_LOADING: Va,
  TRANSCRIPT_LOAD_ERROR: Fa,
  TRANSCRIPT_OPTIONS: ja,
  TRANSCRIPT_RETRY: Ja,
  TRANSCRIPT_UNAVAILABLE: Wa,
  UP_ARROW: $a,
  VIDEO_SETTINGS: Qa,
  VOLUME: xa,
  VOLUME_VALUE: za
};
export {
  a as A11Y_DURATION,
  n as A11Y_SEARCH_HITS,
  t as A11Y_SEARCH_NO_RESULTS,
  s as A11Y_SEARCH_RESULTS_FOUND,
  o as A11Y_SEARCH_RESULTS_FOUND_other,
  T as A11Y_TIMESTAMP_JUMP_HOURS,
  A as A11Y_TIMESTAMP_JUMP_MINUTES,
  i as A11Y_TIMESTAMP_JUMP_SECONDS,
  E as A11Y_TRANSCRIPT_ERROR,
  c as A11Y_TRANSCRIPT_LINE,
  e as A11Y_TRANSCRIPT_LINES,
  S as A11Y_TRANSCRIPT_SAVING,
  _ as A11Y_TRANSCRIPT_SUCCESS,
  u as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  N as ACTION,
  R as ADD_ANNOTATION_AT,
  O as ADD_QUESTION_AT,
  I as ANNOTATIONS,
  r as AUTO,
  k as AUTO_QUALITY,
  C as BACK,
  P as CAPTIONS,
  U as CAPTIONS_LANGUAGE,
  l as CAPTIONS_MANAGE,
  m as CAPTION_DELETE,
  d as CAPTION_FONT_SIZE,
  p as CAPTION_LANGUAGE,
  L as CAPTION_LANGUAGE_AUTOMATIC,
  M as CLEAR_SEARCH,
  D as CLOSE,
  K as COMMENTS,
  h as CONTINUE,
  g as DECREASE_PLAYBACK_SPEED,
  B as DECREASE_VOLUME,
  G as DOWN_ARROW,
  Y as EDIT_CLOSE,
  y as EDIT_CONFIRM,
  H as EDIT_ERROR,
  b as EDIT_SAVING,
  V as EDIT_SUCCESS,
  F as EDIT_TRANSCRIPT,
  j as EDIT_VALIDATION_ERROR,
  J as FULLSCREEN,
  W as HOURS,
  $ as HOURS_other,
  Q as INCREASE_PLAYBACK_SPEED,
  x as INCREASE_VOLUME,
  z as INVERT_COLORS,
  Z as JUMP_TO_PERCENTAGE,
  v as JUMP_TO_START,
  w as KEBAB_MENU,
  X as KEYBOARD_SHORTCUTS,
  f as LANGUAGE,
  q as LEFT_ARROW,
  aa as MAIN_MENU,
  na as MINUTES,
  ta as MINUTES_other,
  sa as MUTE,
  oa as MUTED,
  Ta as NEXT_CAPTION_LANGUAGE,
  Aa as NEXT_HIT,
  ia as OFF,
  Ea as ON_TOP,
  ca as OPEN_ANNOTATION_AT,
  ea as OPEN_COMPLETED_QUIZ_AT,
  Sa as OPEN_QUIZ_AT,
  _a as PAUSE,
  ua as PLAY,
  Na as PLAYBACK_SPEED,
  Ra as PLAYBACK_SPEED_MESSAGE,
  Oa as PREVIOUS_CAPTION_LANGUAGE,
  Ia as PREVIOUS_HIT,
  ra as QUALITY,
  ka as QUALITY_MENU,
  Ca as REPLAY,
  Pa as RESET_PLAYBACK_SPEED,
  Ua as RIGHT_ARROW,
  la as SEARCH_TRANSCRIPT_PLACEHOLDER,
  ma as SECONDS,
  da as SECONDS_other,
  pa as SEEK_BACKWARD,
  La as SEEK_FORWARD,
  Ma as SETTINGS,
  Da as SHORTCUT,
  Ka as SIDEBAR,
  ha as SPACE,
  ga as SPEED_MENU,
  Ba as START_AUTOSCROLL,
  Ga as TOGGLE_CAPTIONS,
  Ya as TOGGLE_MUTED,
  ya as TOGGLE_PLAY_PAUSE,
  Ha as TRANSCRIPT_LINES,
  ba as TRANSCRIPT_LINES_other,
  Va as TRANSCRIPT_LOADING,
  Fa as TRANSCRIPT_LOAD_ERROR,
  ja as TRANSCRIPT_OPTIONS,
  Ja as TRANSCRIPT_RETRY,
  Wa as TRANSCRIPT_UNAVAILABLE,
  $a as UP_ARROW,
  Qa as VIDEO_SETTINGS,
  xa as VOLUME,
  za as VOLUME_VALUE,
  Za as default
};
